export default __webpack_public_path__ + "static/media/midasi_point_th_sp.7ec52856.png";